.orangeLoader {
    margin: 2rem 0 !important;
}

.orangeLoader::after {
    border-color: #fa824c transparent transparent !important;
}
